export default (rawDate: string): Date => {
  const date = Date.parse(rawDate);
  return Number.isNaN(date) ? null : new Date(date);
};
